/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attributes_Status_ApprovedInputs */

const en_attributes_status_approved = /** @type {(inputs: Attributes_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Business Central`)
};

/**
* | output |
* | --- |
* | "In Business Central" |
*
* @param {Attributes_Status_ApprovedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attributes_status_approved = /** @type {((inputs?: Attributes_Status_ApprovedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attributes_Status_ApprovedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attributes_status_approved(inputs)
});